export const EXTENSION_PREFIX = 'ExtensionRouteNamePrefix';
export const EMBEDDED_PREFIX = 'EmbeddedRouteNamePrefix';

export const PAGE_NOT_FOUND_ROUTE_NAME = 'PageNotFound';
export const APP_MAIN_LANDING_PAGE = 'AppMainLandingPage';
/* Right side drawer */
export const BLOCK_EDITOR_ROUTE_NAME = 'BlockEditor';
export const TRIGGER_EDITOR_ROUTE_NAME = 'TriggerEditor';
/* Right side drawer */

/* Builder version-history */
export const BUILDER_VERSION_HISTORY_ROUTE_NAME = 'BuilderVersionHistory';
/* Builder version-history */

/* Builder task-log */
export const BUILDER_TASK_LOG_ROUTE_NAME = 'BuilderTaskLog';
export const BUILDER_DEBUG_MODE_ROUTE_NAME = 'BuilderDebugMode';
export const BUILDER_TASK_LOG_INNER_PAGE = 'BuilderTaskLogInnerPage';
/* Builder task-log */

/* Analytics */
export const ANALYTICS_ROUTE_NAME = 'Analytics';
export const ANALYTICS_TOP_USERS_ROUTE_NAME = 'AnalyticsTopUsers';
export const ANALYTICS_DASHBOARD_ROUTE_NAME = 'AnalyticsDashboard';
export const ANALYTICS_TOP_FEATURES_ROUTE_NAME = 'AnalyticsTopFeatures';
export const ANALYTICS_USAGE_PER_DAY_ROUTE_NAME = 'AnalyticsUsagePerDay';
/* Analytics */
export const LEARN_ROUTE_NAME = 'Learn';
export const INBOX_ROUTE_NAME = 'Inbox';
export const ISSUES_ROUTE_NAME = 'Issues';
export const PROCESS_ROUTE_NAME = 'Process';
export const TASK_LOG_ROUTE_NAME = 'TaskLog';
export const FEATURES_ROUTE_NAME = 'Features';
export const SUBFLOWS_ROUTE_NAME = 'Subflows';
export const PROCESSES_ROUTE_NAME = 'Processes';
export const PLACEMENT_MODE_NAME = 'PlacementRoot';
export const AUTOMATIONS_ROUTE_NAME = 'Automations';
export const CONNECTIONS_ROUTE_NAME = 'Connections';
export const CONNECTIONS_ROUTE_NAME_ROOT = 'ConnectionsRoot';
export const DESTINATIONS_ROUTE_NAME = 'Destinations';
export const TEAM_FEATURES_ROUTE_NAME = 'TeamFeatures';
export const TASK_LOG_INFO_ROUTE_NAME = 'TaskLogInfo';
export const IN_APP_ALERT_RUN_ROUTE_NAME = 'InAppFlowRun';
export const BUTTON_DROPDOWN_ROUTE_NAME = 'ButtonDropdown';
export const CREATE_AND_MANAGE_ROUTE_NAME = 'ManageAndCreate';
export const CUSTOMER_FEATURES_ROUTE_NAME = 'CustomerFeatures';
export const GETTING_STARTED_ROUTE_NAME = 'GettingStartedIntro';
export const PLACEMENT_ADD_ONS_MODE_NAME = 'AllPlacementsAddOns';
export const WORKSPACE_SELECTION_ROUTE_NAME = 'WorkspaceSelector';
export const PLACEMENT_MODE_EVERYTHING_NAME = 'PlacementEverything';
export const EDIT_BUTTON_DROPDOWN_ROUTE_NAME = 'EditButtonDropdown';
export const ACCOUNT_CHANGE_REQUIRED_ROUTE_NAME = 'AccountChangeRequired';
export const TEAM_FEATURES_EVERYTHING_ROUTE_NAME = 'TeamFeaturesEverything';
export const PLACEMENT_FEATURE_TYPES_MODE_NAME = 'AllPlacementsFeatureTypes';

/* Billing */
export const CUSTOMIZE_PLAN_ROUTE_NAME = 'CustomizePlan';
export const BETA_PLAN_ACCOUNT_ACCESS_DENIED = 'AccountWithBetaPlanAccessDenied';
/* Billing */

export const SLACK_WORKSPACE_SELECTION_ROUTE_NAME = 'SlackWorkspaceSelector';
export const ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME = 'IssuesManagementTaskLog';

export const IS_EMBEDDED_PARAM = 'is_embedded';
export const IS_LOADED_FROM_EXTENSION_PARAM = 'is_loaded_from_extension';
